import React from 'react';
import PositionRequirements from './PositionRequirements';
import Attention from '../../ReusableComponents/Attention';
import PortalFieldHelp from './PortalFieldHelp';
import { positionFieldDescriptions } from './registrationFieldDescriptions';

export default function PositionFields({ position, prefix, disabled }) {
  const fields = [
    ['title', 'Nome para publicação', 'text', true],
    ['vacancies', 'Quantidade de vagas', 'number'],
    ['code', 'Código público', 'text'],
    ['locality', 'Localidade', 'text'],
  ];
  return (
    <>
      <p className="form-text">
        Vínculo na OnTest: <strong>{position.source.name}</strong>
        <PortalFieldHelp label="Vínculo na OnTest">
          {positionFieldDescriptions.ontest_processo_id}
        </PortalFieldHelp>
      </p>
      <div className="portal-admin-grid">
        {fields.map(([name, label, type, required]) => (
          <label className="form-label" key={name}>
            <span>
              {label} {required ? <Attention /> : <small className="text-muted">(opcional)</small>}
              <PortalFieldHelp label={label}>{positionFieldDescriptions[name]}</PortalFieldHelp>
            </span>
            <input
              className="form-control"
              name={prefix + name}
              type={type}
              required={required}
              min={type === 'number' ? 0 : undefined}
              step={type === 'number' ? 1 : undefined}
              maxLength={name === 'code' ? 100 : type === 'text' ? 255 : undefined}
              defaultValue={
                position.portal?.[name] ?? (name === 'title' ? position.source.name : '')
              }
            />
          </label>
        ))}
      </div>
      <label className="form-label">
        <span>
          Descrição <small className="text-muted">(opcional)</small>
          <PortalFieldHelp label="Descrição do cargo">
            {positionFieldDescriptions.description}
          </PortalFieldHelp>
        </span>
        <textarea
          className="form-control"
          name={prefix + 'description'}
          rows={3}
          maxLength={20000}
          defaultValue={position.portal?.description || ''}
        />
      </label>
      <PositionRequirements
        name={prefix + 'requirements'}
        value={position.portal?.requirements || ''}
        disabled={disabled}
      />
      <label className="portal-check">
        <input
          type="checkbox"
          name={prefix + 'published'}
          defaultChecked={!!position.portal?.published}
        />{' '}
        Publicar no portal
        <PortalFieldHelp label="Publicar no portal">
          {positionFieldDescriptions.published}
        </PortalFieldHelp>
      </label>
    </>
  );
}
